import {createTableState} from '@/core/services/Helper'

// Menü (container) CRUD + ağaç. Bu uç Laravel paginator'ı doğrudan `data` altında
// döndürür ({data:[...], current_page, per_page, total}) — standart {data, meta}
// zarfından farklı olduğu için pagination'ı elle eşliyoruz.
const state = () => ({
    table: createTableState(),
    filterData: undefined,
})

const getters = {}

const actions = {
    async get({state, commit}, {page, filterData}) {
        commit('setLoading', true)
        state.filterData = filterData

        let params = {page: page?.current, page_limit: page?.pageSize}
        if (state.filterData) params = {...params, ...state.filterData}

        const res = await this._vm.axios.get(this._vm.endpoint.get('menu'), {params})
        const body = res.data ?? {}
        const d = body.data

        let rows = []
        let pg = {current: 0, pageSize: 0, total: 0}

        if (Array.isArray(d)) {
            // Standart zarf: {data:[...], meta:{...}}
            rows = d
            const m = body.meta ?? {}
            pg = {
                current: m.current_page ?? 0,
                pageSize: m.per_page ?? 0,
                total: m.total_record ?? m.total ?? 0,
            }
        } else if (d && typeof d === 'object') {
            // İç içe Laravel paginator: {data:{data:[...], current_page, per_page, total}}
            rows = Array.isArray(d.data) ? d.data : []
            pg = {
                current: d.current_page ?? 0,
                pageSize: d.per_page ?? 0,
                total: d.total ?? 0,
            }
        }

        commit('updateTableData', rows)
        commit('updatePagination', pg)

        setTimeout(() => commit('setLoading', false), 250)
    },

    refresh({state, dispatch}) {
        dispatch('get', {page: state.table.pagination, filterData: state.filterData})
    },

    async show(_, {id}) {
        const res = await this._vm.axios.get(this._vm.endpoint.get('menu') + '/' + id)
        return res.data.data
    },

    // Bir menünün tüm ağacı (pasif öğeler + çeviriler dahil) → {menu, items:[...nested]}
    async tree(_, {id}) {
        const res = await this._vm.axios.get(this._vm.endpoint.get('menu') + '/' + id + '/tree')
        return res.data.data
    },

    async create(_, {data}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('menu'), data)
        return res.data
    },

    async put(_, {id, data}) {
        const res = await this._vm.axios.put(this._vm.endpoint.get('menu') + '/' + id, data)
        return res.data
    },

    async delete({dispatch}, {id}) {
        let ok = []
        if (!id.length) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
            return ok
        }
        for (let i = 0; i < id.length; i++) {
            const {data} = await this._vm.axios.delete(this._vm.endpoint.get('menu') + '/' + id[i])
            if (data.status) {
                this._vm.$message.success(this._vm.$t('messages.deleteOk'))
                ok.push(id[i])
            } else {
                this._vm.$message.error(data.message)
            }
        }
        dispatch('refresh')
        return ok
    },
}

const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateTableData(state, data) {
        state.table.data = data
    },
}

export default {namespaced: true, state, getters, actions, mutations}
